export function composeBridge(existing, deps) {
  const {
    getAllTabs,
    getActiveTab,
    saveTab,
    getActiveCollection,
    getCurrentUserId,
    acknowledgeNotifications,
    readAutoSaveConfig,
    openReaction,
    getSampleInfoForReactionId,
    handleReviewStateChanged,
    handleReviewActionError,
    updateTabs,
	} = deps;

	return {
		version: '1',
		app: {
			tabs: {
				list: getAllTabs,
				active: getActiveTab,
				save: saveTab,
			},
			context: {
				getActiveCollection,
				getCurrentUserId,
			},
			notifications: {
				acknowledge: acknowledgeNotifications,
			},
			autosave: {
				readConfig: readAutoSaveConfig,
			},
		},
		domain: {
			reactions: {
				open: openReaction,
				sampleInfo: getSampleInfoForReactionId,
			},
			review: {
				stateChanged: handleReviewStateChanged,
				actionError: handleReviewActionError,
			},
		},
		ui: {
			tabs: {
				refresh: updateTabs,
			},
		},
	};
}
